import type { ButtonProps } from "../../ui/button";
import { ComboBox, type ComboOption } from "../tables/tableComboBox";

import { SpecialFilterValue } from "../invoices-filters/filter/utils";

export type Props = {
  currentOption?: ComboOption;
  onChange: (value: ComboOption["value"]) => void;
  onFocus?: () => void;
  items: any[];
  variant?: string;
  allowUnknownAccount?: boolean;
  placeholder: string;
  emptyLabel?: string;
  className?: ButtonProps["className"];
  disabled?: boolean;
  fullWidth?: boolean;
  side?: "top" | "bottom";
  sideOffset?: number;
};

export const CostCenterDropdown = ({
  currentOption,
  onChange,
  onFocus,
  items,
  variant,
  placeholder = "Kostenstellen",
  allowUnknownAccount = false,
  className,
  disabled,
  fullWidth,
  sideOffset,
  side,
}: Props) => {
  const costCenterOptions = items.map(
    (costCenter): ComboOption => ({
      label: costCenter.name,
      alternativeLabels: [],
      value: costCenter.costCenterId,
      subLabel: costCenter.identifier,
    }),
  );

  allowUnknownAccount &&
    costCenterOptions.push({
      label: "Unbekannt",
      value: SpecialFilterValue.Unknown,
      alternativeLabels: [],
      subLabel: "Kostenstellen",
    });

  return (
    <ComboBox
      disabled={disabled}
      currentOption={currentOption}
      onChange={onChange}
      items={costCenterOptions ?? []}
      placeholder={placeholder}
      emptyLabel="Keine Kostenstelle"
      variant={variant}
      className={className}
      popoverAlignStart
      fullWidth={fullWidth}
      onFocus={onFocus}
      sideOffset={sideOffset}
      side={side}
    />
  );
};
